import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral from 'numeral';
import axios from 'axios';

import Iframe from 'react-iframe';
import queryString from 'query-string';

import history from '../../utils/history';
import URLS from '../../utils/urls';
import {
  updateQuote,
  requestToPaySelcom,
  CheckPaymentStatus
} from '../../actions/policy';

import Panel from '../../components/Panel';
import { TabHolder, Tab } from '../../components/Tabs';
import StatusMessages from '../../components/StatusMessages';
import BlankState from './../../components/BlankState';

import { revisedPremiumCalculation } from '../../utils/calculations';
import { sendToSelcom } from '../../utils/apiService';
import LocalDB from '../../utils/localDB';
import Pesapal from '../../utils/Pesapal';
import Utils from '../../utils/mci-utils';
import { translations } from '../../i18n/translations';
import mpesa_logo from '../../images/mpesa-logo.png';

class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...LocalDB.fetch('mci_form')
    };
  }

  componentDidMount() {
    const { policy, requestToPaySelcom } = this.props;
    requestToPaySelcom(policy.quote.id);
  }
  onClick(id) {
    this.props.CheckPaymentStatus(id).then(() => {
      const { is_paid } = this.props.policy;
      if (is_paid) {
        //navigate to certificate page
        history.push('/buy/get-certificate');
      }
    });
  }

  render() {
    const {
      conveyance,
      packaging,
      transshipment,
      warehousing,
      selected_goods,
      selected_insurer,
      other_rates,
      currency_rate,
      paymentUrl,
      isPaymentUrl,
      icc_class
    } = this.state;

    let goodsTotalValue = Utils.sum(selected_goods, 'goods_value'),
      premium = revisedPremiumCalculation(
        selected_insurer,
        selected_goods,
        conveyance,
        packaging,
        transshipment,
        warehousing,
        currency_rate.rate,
        other_rates,
        icc_class
      );

    const menuItems = [
      { id: 'm-pesa', name: 'Vodacom-M-Pesa', active: true },
      { id: 'tigo-pesa', name: 'Tigo Pesa' },
      { id: 'airtel-money', name: 'Airtel Money' },
      { id: 'halo-pesa', name: 'Halo Pesa' },
      { id: 'selcom-card', name: 'Selcom Card' },
      { id: 'credit-debit-cards', name: 'Credit/Debit Cards' }
    ];

    const { policy } = this.props;
    const {
      selcomPaymentPending,
      checkPaymentStatusPending
    } = this.props.policy;

    const { selcomMessage, quote, is_paid } = policy;
    const error = selcomMessage ? selcomMessage.Error : {};
    return (
      <div className="row">
        <div className="col-sm-5">
          <Panel title="Policy Details">
            <div className="clearfix">
              <dl>
                <dt>Name of Insured:</dt>
                <dd>{this.props.policy.quote.insured_data.name}</dd>
              </dl>
              <dl>
                <dt>Tax ID Number:</dt>
                <dd>{this.props.policy.quote.tra_pin || '-'}</dd>
              </dl>
            </div>
            <div className="clearfix" style={{ margin: '1em 0' }}>
              <dl>
                <dt>Order Number:</dt>
                <dd>{this.props.policy.quote.order_number}</dd>
              </dl>
              <dl>
                <dt>Total Sum Insured:</dt>
                <dd>
                  {currency_rate.currency_code +
                    ' ' +
                    numeral(goodsTotalValue).format('0,0.00')}
                </dd>
              </dl>
            </div>
            <div className="clearfix amount-due" style={{ margin: '1em 0' }}>
              <dl>
                <dt>Amount Due:</dt>
                <dd>
                  {translations.currency +
                    numeral(this.props.policy.quote.premium).format('0,0.00')}
                </dd>
              </dl>
            </div>
          </Panel>
        </div>

        <div className="col-sm-7 payment-options">
          <div className="messages">
            {this.state.error ? (
              <div className="alert alert-danger" role="alert">
                {this.state.errorMessage}
              </div>
            ) : (
              ''
            )}
          </div>

          {error && error.length > 0 ? (
            <StatusMessages type="error" message={error} />
          ) : (
            <div>
              {policy.selcomPaymentPending ? (
                <StatusMessages
                  type="success"
                  message="We have requested payment information from Selcom. Waiting
            for a response shortly"
                />
              ) : null}

              {policy.checkPaymentStatusPending ? (
                <BlankState
                  data={policy.is_paid}
                  dataName="Payment Status"
                  isDataLoading={checkPaymentStatusPending}
                />
              ) : null}

              {!is_paid ? (
                <StatusMessages type="warning" message="Payment is pending!" />
              ) : null}
              <TabHolder menuItems={menuItems}>
                <Tab
                  menuId={menuItems[0].id}
                  style={{ height: '30em', position: 'relative' }}
                  isActive={true}
                >
                  <h6>How to pay by Selcom Pay via Vodacom M-Pesa</h6>
                  <ol>
                    <li>Dial *150*00#</li>
                    <li>Choose 4 - Lipa by M-Pesa</li>
                    <li>
                      Choose 4 - Enter business number Enter:{' '}
                      <strong>123123</strong>
                    </li>
                    <li>
                      Enter reference number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        ''
                      )}
                    </li>
                    <li>
                      Enter Amount :{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>
                    <li>Enter PIN</li>
                    <li>You will receive a confirmation SMS</li>
                  </ol>
                </Tab>
                <Tab menuId={menuItems[1].id}>
                  <h6>How to pay Selcom Pay via Tigo Pesa</h6>
                  <ol>
                    <li>Dial *150*01#</li>
                    <li>Pay Marchant</li>
                    <li>Choose 2 - Pay Masterpass QR Marchant</li>
                    <li>
                      Enter 8 - digit Merchant Number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        123123
                      )}
                    </li>
                    <li>
                      Enter amount :{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>
                    <li>Enter PIN</li>
                    <li>You will receive a confirmation</li>
                  </ol>
                </Tab>
                <Tab menuId={menuItems[2].id}>
                  <h6>How to pay by Selcom Pay via Airtel Money</h6>
                  <ol>
                    <li>Dial *150*60#</li>
                    <li>Choose 5 - Make Payments</li>
                    <li>Choose 2 - Choose Business</li>
                    <li>Choose 3 - Purchases</li>
                    <li>Choose 3 - Selcom Pay/Masterpass</li>
                    <li>
                      Enter Amount:{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>
                    <li>
                      Enter Pay Number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        123123
                      )}
                    </li>
                    <li>Enter PIN</li>
                    <li>You will receive confirmation SMS</li>
                  </ol>
                </Tab>

                <Tab menuId={menuItems[3].id}>
                  <h6>How to pay by Selcom Pay via Halo Pesa</h6>
                  <ol>
                    <li>Dial *150*88#</li>
                    <li>Choose 4 - Pay by Halo Pesa</li>
                    <li>Choose 2 - Selcom Pay/Masterpass</li>
                    <li>
                      Enter Pay Number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        123123
                      )}
                    </li>
                    <li>
                      Enter Amount:{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>

                    <li>Enter PIN</li>
                    <li>You will receive confirmation SMS</li>
                  </ol>
                </Tab>
                <Tab menuId={menuItems[4].id}>
                  <h6>How to pay by Selcom Pay via Selcom Card</h6>
                  <ol>
                    <li>Dial *150*50#</li>
                    <li>Enter PIN</li>
                    <li>Choose 2 - Selcom Pay/Masterpass</li>
                    <li>
                      Enter Pay Number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        123123
                      )}
                    </li>
                    <li>
                      Enter Amount:{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>
                    <li>You will receive confirmation SMS</li>
                  </ol>
                </Tab>
                <Tab menuId={menuItems[5].id}>
                  <h6>How to pay using Selcom Online</h6>
                  <ol>
                    <li><a href="https://tz.selcom.online/" target="_blank">Visit Selcom Pay</a></li>
                    <li>Personal Info Section - Enter Full Name, Email and Contact Phone Number</li>
                    <li>
                      Enter Pay Number:{' '}
                      {selcomMessage ? (
                        <strong>{selcomMessage.payment_token}</strong>
                      ) : (
                        123123
                      )}
                    </li>
                    <li>
                      Enter Amount:{' '}
                      {quote ? (
                        <strong>{Utils.parseAmount(quote.premium)}</strong>
                      ) : (
                        '0'
                      )}{' '}
                    </li>
                    <li>Click Submit and continue with the payment Instructions to complete the process
                    </li>
                  </ol>
                </Tab>
                <div className="alert alert-info">
                  <p>
                    <i className="icon ion-android-alert" /> Please follow the
                    above instructions to make a payment then wait for a minute
                    before you press the Complete Payment Button!
                  </p>
                </div>
                <button
                  className="btn btn-success"
                  onClick={this.onClick.bind(this, quote.id)}
                >
                  Complete Payment
                </button>
              </TabHolder>
            </div>
          )}
        </div>
        <div className="clearfix col-sm-12">
          <hr />
          <span
            className="btn btn-warning"
            onClick={() => {
              history.back();
            }}
          >
            <span className="glyphicon glyphicon-menu-left" /> Back
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  policy: state.policy,
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { updateQuote, requestToPaySelcom, CheckPaymentStatus },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);



// WEBPACK FOOTER //
// ./src/pages/buy/Payment.jsx